import PropTypes from "prop-types";
import { FormProvider as Form } from "react-hook-form";

CFormProvider.propTypes = {
  children: PropTypes.node,
  methods: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default function CFormProvider({
  children,
  onSubmit,
  methods,
  className,
}) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} className={className}>
        {children}
      </form>
    </Form>
  );
}
